import React from 'react';
import ScrollToTopOnMount from './ScrollToTopOnMount';

const RefundPolicy = () => {
  return (
   <><div> welcome DI health</div></>
  );
};





export default RefundPolicy